var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.infoBlockStyle},[_c('div',{class:_vm.$style.infoBlockIcon},[_c('app-svg-icon',{class:_vm.$style.infoIcon,attrs:{"name":"ic_info"}})],1),_c('p',{class:_vm.$style.infoBlockText},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }